module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_408905526_L-5450edb45f56df29aa3630f321d65692.jpg";